export default "__VITE_ASSET__1f9d481f__"